import { useQuery } from "@tanstack/react-query";
import { getCategoriesForSession } from "services/Categories.services";

import { useCompany } from "hooks/useCompany";

import type { CategorySessionResponse } from "types/Category.type";

export default function useCategoriesForSession() {
  const { company } = useCompany();
  const {
    data: categoriesSession,
    isLoading: isLoadingSession,
    error: errorSession,
  } = useQuery<CategorySessionResponse>({
    queryKey: ["categoriesSession"],
    queryFn: () => {
      const languageId = company?.companySettings?.languageId;
      if (!languageId) {
        throw new Error("Language ID is not available");
      }
      return getCategoriesForSession({ language: languageId });
    },
  });

  return {
    categoriesSession,
    isLoadingSession,
    errorSession,
  };
}
